import { DisplayType, MenuState } from 'common/ducks/menu'
import { SubVertical } from 'common/constants'
import { axios } from 'common/utils'
import { MenuLayer } from 'common/types/entities/mongo/menu'

export const fetchCompositeLayers = async (
  subVertical: SubVertical,
  displayType: DisplayType,
  layer1MenuId?: string,
  layer2MenuId?: string,
) => {
  const result = await axios.get<MenuLayer[]>(`/v1/composite-menus`, {
    params: { subVertical, displayType, layer1MenuId, layer2MenuId },
  })
  return result && (result.data || [])
}

export const getSelectedIds = (menuState: MenuState) => {
  const layer2SelectedId = menuState.third.selectedId ? menuState.third.selectedId : menuState.second.selectedId
  if (!layer2SelectedId && !menuState.first.selectedId) return null

  return [menuState.first.selectedId, layer2SelectedId]
}
